import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'constants/queryKeys';
import { getCleanedUrlParams, showError, showSuccess } from '@utils';
import { FILTER_RULE_ENUMS } from '@constants';
import { communicationServices } from '@services';
import { URLS } from 'layouts/DrawerLayout/constants';
import { handleMailBoxes } from './utils';

export const MAILBOXES_PAGE_SIZE = 50;

export const useMailBoxesOperations = () => {
  const { push, query } = useRouter();

  const page = query?.page || 1;
  const orderBy = query?.orderBy || 'createdAt';
  const order = query?.order || 'desc';
  const code = query?.code || '';
  const pageSize = query?.pageSize || MAILBOXES_PAGE_SIZE;

  const params = getCleanedUrlParams({ page, orderBy, order, code, pageSize });

  const mailBoxesResponse = useQuery(
    [QUERY_KEYS.GET_MAILBOXES_KEY, params],
    () => {
      const payload = {
        type: FILTER_RULE_ENUMS.EmptyRuleType,
      };
      return communicationServices.getEmailBoxes(params, payload);
    }
  );

  const validateMailbox = useCallback(async () => {
    try {
      if (!code) return;
      const id = localStorage.mailboxId;
      await communicationServices.validateEmailBox(id, {
        code,
      });
      localStorage.removeItem('mailboxId');
      showSuccess('The mailbox is validated');
      await mailBoxesResponse.refetch();
      push({
        pathname: URLS.mailBoxes,
        query: {
          page,
          orderBy,
          order,
        },
      });
    } catch (error) {
      showError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, page, orderBy, order]);

  useEffect(() => {
    validateMailbox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  useEffect(() => {
    if (mailBoxesResponse?.error) {
      showError(mailBoxesResponse.error);
    }
  }, [mailBoxesResponse?.error]);

  const mailBoxes = handleMailBoxes(mailBoxesResponse?.data?.data || []);
  return {
    page,
    pageSize: parseInt(pageSize, 10) || MAILBOXES_PAGE_SIZE,
    total: mailBoxesResponse?.data?.meta?.total,
    loading: mailBoxesResponse.isLoading,
    isFetched: mailBoxesResponse.isFetched,
    mailBoxes,
    getMailBoxes: mailBoxesResponse.refetch,
  };
};
